module.exports = __webpack_public_path__ + "static/net-57efacb78c60ecc3554b2ed98bd95dd6.png";